import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PreAlert } from '../../../../models/pre-alert.models';

@Component({
  selector: 'app-delete-confirmation',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './delete-confirmation.component.html',
  styleUrl: './delete-confirmation.component.css'
})
export class DeleteConfirmationComponent {
  @Input() preAlert!: PreAlert;
  @Input() isVisible: boolean = false;
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  confirmationText: string = '';

  get isValid(): boolean {
    return this.confirmationText === this.preAlert.ladingBill;
  }

  onConfirm(): void {
    if (this.isValid) {
      this.confirmed.emit();
    }
  }

  cancel(): void {
    this.confirmationText = '';
    this.cancelled.emit();
  }

  onModalClick(event: Event): void {
    // Prevent modal from closing when clicking inside modal content
    event.stopPropagation();
  }

  onOverlayClick(): void {
    // Close modal when clicking on overlay
    this.cancel();
  }
}